// src/services/emailTemplateService.js
import { apiRequest } from '../api/client';
import { endpoints } from '../api/endpoints';

export function getTemplates(params = {}) {
    const qs = new URLSearchParams(params).toString();
    return apiRequest(`${endpoints.EmailTemplates}${qs ? `?${qs}` : ''}`, { method: 'GET' });
}

export function getTemplate(id) {
    return apiRequest(endpoints.EmailTemplate(id), { method: 'GET' });
}

export function createTemplate(template) {
    return apiRequest(endpoints.EmailTemplates, {
        method: 'POST',
        body: JSON.stringify(template),
    });
}

export function updateTemplate(id, template) {
    return apiRequest(endpoints.EmailTemplate(id), {
        method: 'PUT',
        body: JSON.stringify(template),
    });
}

export function deleteTemplate(id) {
    return apiRequest(endpoints.EmailTemplate(id), { method: 'DELETE' });
}

export function duplicateTemplate(id) {
    return apiRequest(endpoints.EmailTemplateDuplicate(id), { method: 'POST' });
}

export function toggleTemplateFavorite(id) {
    return apiRequest(endpoints.EmailTemplateFavorite(id), { method: 'POST' });
}

export function getTemplateVersions(id) {
    return apiRequest(endpoints.EmailTemplateVersions(id), { method: 'GET' });
}
